import React from 'react';
import { Link } from "react-router-dom";
import Imagegroup from './../Images/image-group.svg';

export default function HeaderTwo() {
    return (
        <div id="header" className="header2">
            <header>
                <div className="container-fluid float-none">
                    <div className="logo float-none m-auto"><Link to="/"><img src={Imagegroup} alt="IMAGE Group" title="IMAGE Group" width="115" height="34" /></Link></div>
                </div>
            </header>
        </div>
    )
}
